module.exports = __webpack_public_path__ + "img/brain.cf452cb4.svg";